var map = {
	"./2.png": 1388,
	"./WhatsApp Image 2025-09-17 at 12.16.29 (6).jpeg": 3955,
	"./WhatsApp Image 2025-09-18 at 14.12.36 (4).jpeg": 9082,
	"./WhatsApp Image 2025-09-26 at 11.05.54 AM(1).jpeg": 4839,
	"./WhatsApp Image 2025-09-26 at 11.05.54 AM.jpeg": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4935;